import {
  ReviewCard,
  ReviewCardAuthor,
  ReviewCardDate,
  ReviewCardIcon,
  ReviewCardMeta,
  ReviewCardText,
} from '@vs-shop/commerce-ui/reviewCard';
import { IconHeureka } from '@vs-shop/ui/icons';
import { RatingStars } from '@vs-shop/ui/rating';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

import { IntlDate } from '../../intl/Intl';

import type { HomepageHeurekaReview } from '../../../../effect/schema/openapi/backend';

type Props = {
  heurekaReview: HomepageHeurekaReview;
};

/**
 * A Heureka review as rcprofi arranges it: the quote at the top of the cell,
 * the attribution pinned to its foot.
 *
 * `justify-between` is this arrangement's, not the card's — the shared card
 * distributes nothing, so the brand that reads mark-first composes the same
 * parts in its own order.
 */
export default function HeurekaReview({ heurekaReview }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  const { customerName, text, posted, totalRating } = heurekaReview;

  return (
    <ReviewCard className="justify-between">
      <ReviewCardText>{text}</ReviewCardText>

      <div className="flex gap-x-5">
        <ReviewCardIcon>
          <IconHeureka variant="blue" />
        </ReviewCardIcon>
        <div className="flex flex-col gap-y-2">
          <ReviewCardMeta>
            <ReviewCardAuthor>
              {customerName ??
                intl.formatMessage({
                  id: 'heurekaReview.customerName.fallback.verifiedUser',
                  defaultMessage: 'Ověřený zákazník',
                })}
            </ReviewCardAuthor>
            <ReviewCardDate>
              <IntlDate value={posted} />
            </ReviewCardDate>
          </ReviewCardMeta>
          <RatingStars rating={totalRating} />
        </div>
      </div>
    </ReviewCard>
  );
}
